import { CSSProperties, VFC } from 'react';

import { PhotoShootHeaderItem, PhotoShootListItem, PhotoShootMenuItem } from '../../types';

export enum VirtualizedListRowType {
  MENU_ITEM = 'menu_item',
  CATEGORY = 'category',
}

export type ListRowMenuItemProps = PhotoShootMenuItem & {
  type: VirtualizedListRowType.MENU_ITEM;
  isLoading?: boolean;
  isReadOnly?: boolean;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUnlink: ({ itemId, imageId }: { itemId: string; imageId: string }) => void;
};

// it might require some alignment once we actually support it
export type ListRowCategoryProps = {
  type: VirtualizedListRowType.CATEGORY;
  id: string;
  name: Localization[];
};

export type VirtualizedListRowProps = ListRowMenuItemProps | ListRowCategoryProps;
export type VirtualizedListConfig = Record<
  VirtualizedListRowType,
  {
    component: VFC<VirtualizedListRowProps & { style: CSSProperties }>;
    getRowHeight: (item: VirtualizedListRowProps) => number;
  }
>;

export type CoverItem = (PhotoShootHeaderItem | PhotoShootListItem) & {
  isLoading?: boolean;
  isReadOnly?: boolean;
  onUnlink: ({ itemId, imageId }: { itemId: string; imageId: string }) => void;
};

export enum PanelTabs {
  MENU_ITEMS = 'menuItems',
  COVERS = 'covers',
}
